import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import NL from "../assets/sprites/nl.png";
import EN from "../assets/sprites/gb.png";
import FR from "../assets/sprites/fr.png";
import { Storage } from "../backend/enums";

const options = [
  { src: NL, alt: "nl", label: "NL" },
  { src: EN, alt: "en", label: "EN" },
  { src: FR, alt: "fr", label: "FR" }
];

export default function LanguageSelector() {
  const storedLanguage = localStorage.getItem(Storage.Language);
  const initialOption = options.find((option) => option.alt === storedLanguage) || options[0];
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(initialOption);
  const { i18n, t } = useTranslation();
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setIsOpen(false);
    setSelected(option);
    i18n.changeLanguage(option.alt);
    localStorage.setItem(Storage.Language, option.alt);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex h-10 min-w-16 items-center gap-2 border border-white/20 bg-transparent px-3 text-sm font-semibold text-white transition duration-200 hover:border-[#B08D57] hover:text-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57]"
        type="button"
        aria-label={t("language.label")}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((previous) => !previous)}
      >
        <img className="h-4 w-6 object-cover grayscale" alt="" src={selected.src} />
        <span>{selected.label}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-28 border border-white/10 bg-[#111111] p-1 shadow-xl">
          {options.map((option) => (
            <button
              key={option.alt}
              className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm transition duration-200 hover:bg-white/10 hover:text-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B08D57] ${
                option.alt === selected.alt ? "text-[#B08D57]" : "text-white"
              }`}
              type="button"
              onClick={() => handleSelect(option)}
            >
              <img className="h-4 w-6 object-cover grayscale" alt="" src={option.src} />
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
